var $8664c125579aad3b$exports = {};
$8664c125579aad3b$exports = {
    "removeButtonLabel": `Fjern`,
    "removeDescription": `Trykk p\xe5 Slett for \xe5 fjerne taggen.`
};


export {$8664c125579aad3b$exports as default};
//# sourceMappingURL=nb-NO.mjs.map
